export default __webpack_public_path__ + "static/media/background@2x.d41af782.png";